import type FormState from '../FormState.type'

export const getNextStep = (
  currentStep: string,
  formState: FormState,
  hasImportantContacts?: boolean,
  isGP?: boolean
) => {
  if (!isGP && currentStep === 'start') {
    if (formState.capacity === true) return 'ability'
    if (formState.capacity === false) {
      return hasImportantContacts ? 'lpa' : 'witness'
    }
  }
  if (!isGP && currentStep === 'ability') {
    if (formState.ability === true) return 'sign'
    if (formState.ability === false) return 'witness'
  }
  if (!isGP && currentStep === 'witness') {
    if (formState.name && formState.relationship) return 'sign'
  }
  if (currentStep === 'sign') {
    if (formState.imageURL && formState.hasConfirmed) return 'confirm'
  }

  if (currentStep === 'start-clean') {
    return 'sign'
  }

  if (currentStep === 'lpa') {
    if (formState.lpaValue !== undefined) return 'witness'
  }
  return null
}

export const getPercentage = (value?: number) => {
  switch (value) {
    case 1:
      return 33
    case 2:
      return 66
    case 3:
      return 100
    default:
      return 0
  }
}
